
import CloseIcon from '../icons/CloseIcon.vue';
import AlertIcon from '~/components/ui/icons/AlertIcon.vue';
import CustomModal from '../molecule/CustomModal.vue';
import { mapActions } from 'vuex';
export default {
  name: 'UnrankedPortfolioConfirmationModal',
  components: { CustomModal, CloseIcon, AlertIcon },
  props: {
    isPublic: {
      type: Boolean,
      default: false,
    },
    itemCountCondition: {
      type: Boolean,
      default: false,
    },
    allocationCondition: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions('modals', ['resetSubmitOperationState']),
    handleConfirm() {
      this.$emit('confirm');
    },
    handleClose() {
      this.$emit('close');
    },
  },
};
